import { max, min, scaleBand, scaleLinear, scaleTime, timeDay } from 'd3';
import { ObrasBars } from './ObrasBars';
import { Axis } from './Axis';
import { useEffect, useState } from 'react';
import { getGanttData } from '../../services/charts.service';
import { DraggableWrapper } from '../components/wrappers/DraggableWrapper';



export function NewGantt() {

    const [obras, setObras] = useState([]);

    const [obrasTotalHeight, setObrasTotalHeight] = useState(0);

    const maquinasBarHeight = 50;
    const chartMargins = { top: 40, bottom: 40, right: 50, left: 50 };


    useEffect(() => {
        getGanttData().then((r) => setObras(r));
    }, [])

    useEffect(() => {
        const totalHeight = obras.reduce((acc: number, curr: any) => acc + curr.entregas.reduce((a: number, c: any) => a + c.maquinasGantt.length * maquinasBarHeight, 0), 0);
        setObrasTotalHeight((totalHeight + chartMargins.top + chartMargins.bottom) + 2 * 50);
    }, [obras])

    if (obras.length == 0) return <></>



    const chartWidth = 5000;

    const minDate = min(obras.flatMap((o: any) => o.entregas.map((e: any) => e.startingDate)));
    const maxDate = max(obras.flatMap((o: any) => o.entregas.map((e: any) => e.realDeliveryDate)));


    const tScale = scaleTime()
        .domain([minDate.getTime(), maxDate.getTime()])
        .range([chartMargins.left, chartWidth - chartMargins.left])
        .nice(timeDay)


    const yScale = scaleBand()
        .domain(obras.map((o: any) => o.number))
        .range([chartMargins.top, obrasTotalHeight - chartMargins.bottom])


    return (
        <div className='pb-5'>
            <h1 className='font-bold text-[1.5em] pl-5 pb-1'>Gantt Obras</h1>
            <DraggableWrapper className="w-auto max-h-[700px] overflow-y-auto overflow-x-auto border rounded-lg mx-3 px-5 py-2 pt-6 pb-6">

                <svg width={chartWidth} height={obrasTotalHeight}>
                    <Axis xScale={tScale} innerHeight={obrasTotalHeight} />
                    <ObrasBars maquinasBarHeight={maquinasBarHeight} obras={obras} xScale={tScale} yScale={yScale} chartHeight={obrasTotalHeight} margins={chartMargins} />
                </svg>
            </DraggableWrapper>
        </div>
    )



}